import {
  IconButton,
  Icons,
  ListItem,
  ListItemAvatar,
  ListItemText,
  withProps,
  tokens,
} from '@cast/design-system';

const OrganizationListItemText = withProps(ListItemText, {
  primaryTypographyProps: { variant: 'P12M', component: 'span' },
  secondaryTypographyProps: { variant: 'P10R' },
});

type CreateOrganizationButtonProps = {
  onCreateNewOrganization: (enterpriseOrgId?: string) => void;
  selectedEnterpriseId?: string;
};

export const CreateOrganizationButton = ({
  onCreateNewOrganization,
  selectedEnterpriseId,
}: CreateOrganizationButtonProps) => {
  return (
    <ListItem
      startAdornment={
        <ListItemAvatar>
          <IconButton variant="secondary" size="md">
            <Icons.Plus />
          </IconButton>
        </ListItemAvatar>
      }
      multiline
      sx={{
        borderTop: tokens.theme.border.structural.neutral,
      }}
      onClick={() => onCreateNewOrganization(selectedEnterpriseId)}
      testId="new-org-btn"
    >
      <OrganizationListItemText primary="Create organization" />
    </ListItem>
  );
};
